import React, { useEffect, useState } from "react";
import { Bubble } from "react-chartjs-2";
import { Chart, Filler } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { default_bubblechart_data } from "../../constants/charts";
import { getBubbleChartData } from "../../utils/financialInsightsUtils";

Chart.register(Filler);
Chart.register(ChartDataLabels);

const chart_spacing = {
  x: 100,
  y: 10,
};

const options = (min_max_values, data) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    // stepped: true,
    plugins: {
      datalabels: { display: false },
      // Uncomment to display operator's initials on basket map points
      // datalabels: {
      //   anchor: "center",
      //   align: "center",
      //   color: "white",
      //   formatter: (value) => {
      //     const isAnonymized = value?.infos?.name === "Anonymized";
      //     return isAnonymized
      //       ? "-"
      //       : `${value?.infos?.first_name?.charAt(0)}${value?.infos?.last_name?.charAt(0)}`;
      //   },
      //   offset: 2,
      //   padding: 0,
      // },
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            const dataPoint = data.datasets[context.datasetIndex].data[context.dataIndex];
            return `${dataPoint.infos.name.toUpperCase()} - Calls: ${
              dataPoint.y
            }, Average Basket: ${dataPoint.x}€`;
          },
          labelTextColor: () => "#fff",
        },
        displayColors: false,
        backgroundColor: "#4318FF",
        borderColor: "#030229",
        yAlign: "bottom",
        titleSpacing: 2,
        titleAlign: "center",
        bodyAlign: "center",
        padding: { x: 18, y: 15 },
        bodyFont: { family: "DM Sans", weight: "bold", size: 11 },
        labelFont: { family: "DM Sans", weight: "bold", size: 11 },
        titleColor: "#dfdfdf",
      },
    },
    elements: {
      point: { borderWidth: 0, radius: 12 },
      line: { tension: 0.5 },
    },
    scales: {
      y: {
        display: true, // hide y-axis legend
        grid: {
          display: true, // hide y-axis grid lines
        },
        // TODO Change with the max and min values of the data
        max: min_max_values.y.max + chart_spacing.y,
        min: 0,
        ticks: {
          // font: { size: 12, family: "Nunito" },
          // color: "#C3C2CB",
          // stepSize: 25,
          // padding: 10,
          stepSize: 10,
        },
        border: { display: true, color: "#4318FF", width: 2, dash: [4, 2], dashOffset: 2 },
        // // grid: { drawBorder: false, color: "#F2F2F4", borderWidth: 2 },
        // beginAtZero: true,
      },
      x: {
        display: true, // hide y-axis legend
        grid: {
          display: true, // hide y-axis grid lines
        },
        max: min_max_values.x.max + chart_spacing.x,
        suggestedMin: 0,
        ticks: {
          font: { size: 12, family: "DM Sans" },
          color: "#C3C2CB",
          stepSize: 100,
        },
        border: { display: true, color: "#4318FF", width: 2, dash: [4, 2], dashOffset: 2 },
        // grid: { color: "rgba(0, 0, 0, 0)" },
        beginAtZero: true,
      },
    },
  };
};

const BubbleChart = (props) => {
  const { data } = props;
  const [bubblechartData, setBubblechartData] = useState(default_bubblechart_data);

  useEffect(() => {
    const bubble_chart_data = getBubbleChartData(data);
    if (bubble_chart_data) setBubblechartData(bubble_chart_data);
  }, [data]);

  const flatData = [];
  data.forEach((item, i) => {
    // Anonymized entries
    if (Array.isArray(item)) {
      item.forEach((subItem) => {
        flatData.push(subItem);
      });
    } else {
      flatData.push(item);
    }
  });

  const min_x_value = Math.min(...flatData.map((item) => item.average_basket));
  const max_x_value = Math.max(...flatData.map((item) => item.average_basket));

  const min_y_value = Math.min(...flatData.map((item) => item.outgoing_calls_count));
  const max_y_value = Math.max(...flatData.map((item) => item.outgoing_calls_count));

  const min_max_values = {
    x: { min: min_x_value, max: max_x_value },
    y: { min: min_y_value, max: max_y_value },
  };
  return (
    <Bubble
      plugins={[ChartDataLabels]}
      options={options(min_max_values, bubblechartData)}
      data={bubblechartData}
    />
  );
};

export default BubbleChart;
